export const DATE_FORMAT_DELIVERY: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
}
